import { svgUrl } from "@/utils";
import { getWidgetComponent } from "@/components/widgets/builderWidgets";
import { Helpers } from "./Helpers";

export const helpers: Helpers = {
  svgUrl: svgUrl,
  getWidgetComponent: getWidgetComponent,
};
